<template>
  <div class="code-staff">
    <div class="code-staff-search">
      <div class="code-search-left">
        <el-tag title="选择员工" class="add-per-input" :closable="this.searchMenNames.length === 0 ? false : true"
          @close="searchCloseTag" type="medium" effect="plain" @click="clickAddMember(true)">
          <span v-if="searchMenNames.length === 0">选择员工</span>
          <span v-for="(item, index) in searchMenNames" :key="index">{{ item.name }}<span
              v-show="searchMenNames.length > 1 && index != searchMenNames.length - 1">,</span></span>
        </el-tag>
        <el-input placeholder="使用场景" suffix-icon="el-icon-search" size="mini" @blur="searchFn" @clear="searchFn"
          v-model="formInline.sceneName" clearable style="width: 180px; margin-right: 10px">
        </el-input>
        <el-date-picker v-model="searchSelectTime" size="mini" :editable="false" type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss" range-separator="~" start-placeholder="创建时间" end-placeholder="创建时间"
          @change="selectTime" clearable style="width: 240px; margin-right: 10px"
          :default-time="['00:00:00', '23:59:59']">
        </el-date-picker>
        <el-input placeholder="创建人" suffix-icon="el-icon-search" size="mini" @blur="searchFn" @clear="searchFn"
          v-model="formInline.creatorName" clearable style="width: 180px; margin-right: 10px">
        </el-input>
      </div>
      <div class="code-search-right">
        <div class="csr-left">
          <el-button type="primary" size="mini" v-if="authorityContainer[0]" @click="openCode">新建活码</el-button>
          <el-button size="mini" v-if="authorityContainer[0]" @click="batchDelete()">批量删除</el-button>
          <el-button size="mini" v-if="authorityContainer[1]" @click="batchDownLoadHandle()">批量下载</el-button>
        </div>
        <div class="csr-right">
          <el-button size="mini" v-if="authorityContainer[2]" @click="toLabelManagement('标签管理')">标签管理</el-button>
          <el-button size="mini" v-if="authorityContainer[3]" @click="toLabelManagement('欢迎语管理')">欢迎语管理</el-button>
        </div>
      </div>
    </div>
    <el-row :gutter="20">
      <el-col>
        <el-table size="small" :data="tableData" fit highlight-current-row align="center"
          :header-cell-style="{ background: '#F9F9F9' }" height="calc(100vh - 274px)"
          @selection-change="handleSelectionChange" @row-click="handleRowClick" @row-dblclick="handleRowDBClick"
          ref="cusChatTable" style="font-size: 13px">
          <el-table-column type="selection" min-width="55"></el-table-column>
          <el-table-column prop="staffName" label="使用员工" min-width="120">
            <template slot-scope="scope">
              <div class="name-wrap">
                <span v-for="(item, index) in scope.row.configList" :key="index">{{ item.userName }}<span
                    v-show="index != scope.row.configList.length - 1 && scope.row.configList.length != 1">,</span></span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="sceneName" label="使用场景" min-width="120"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="120">
              <template slot-scope="scope">
              <div>{{ getfTime(scope.row.createTime) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="creatorName" label="创建人" min-width="120"></el-table-column>

          <el-table-column prop="qrType" label="类型" min-width="120">
            <template #default="scope">

              <span v-if="scope.row.qrType == 0">单人</span>
              <span v-else-if="scope.row.qrType == 1">批量单人</span>
              <span v-else-if="scope.row.qrType == 2">多人</span>
            </template></el-table-column>
          <el-table-column label="操作" min-width="150">
            <template slot-scope="scope">
              <el-button type="text" size="small" class="table-btns" @click.stop="downloadHandle(scope.row)"
                v-show="scope.row.qrStatus == 2" :disabled="scope.row.download && !authorityContainer[1]">
                <span v-show="!scope.row.download">下载</span>
                <span v-show="scope.row.download">下载中...</span>
              </el-button>
              <el-button type="text" size="small" class="table-btns" :disabled="!authorityContainer[0]"
                @click.stop="editHandle(scope.row)" v-show="scope.row.qrStatus == 2">详情</el-button>
              <el-button type="text" size="small" class="table-btns" :disabled="!authorityContainer[0]"
                @click.stop="handleDel(scope.row)" v-show="scope.row.qrStatus == 2">删除</el-button>
              <span v-show="scope.row.qrStatus == 1" style="color:#afadad">生成中...</span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <Pagination v-bind:childMsg="pageparm" :pageSizes="pageSizes" @callBack="callBack"></Pagination>
    <!-- 添加人员树 -->
    <!-- <AddMemberView 
      :title="title"
      :dialogVisibleTree="dialogVisibleTree" 
      :currentSelectMember='currentSelectMember' 
      @closeTree='closeTree' 
      @clickSubmitTree='clickSubmitTree'
    ></AddMemberView> -->
    <StaffTree :title="title" :dialogVisibleTree="dialogVisibleTree" :currentSelectMember='currentSelectMember'
      @closeTree='closeTree' @clickSubmitTree='clickSubmitTree'></StaffTree>
    <!-- 新建活码 -->
    <CreateActiveCode :activeCodeVisible="activeCodeVisible" :editData="editData" :ceTitle="ceTitle"
      @createCancelHandle="createCancelHandle" @createSuccess="createSuccess">
    </CreateActiveCode>
  </div>
</template>
<script>
import StaffTree from '@/components/staffTree/staffTree.vue'
import { getActivityList, delActiveCode, batchDelActiveCode } from "@/api/activeCode/activeCode.js";
import CusChatView from "../chat/components/CusChatView";
import AddMemberView from "./components/addMember.vue";
import CreateActiveCode from "./createCode/CreateActiveCode.vue";
/** 格式化时间函数 */
import { timeFormat } from "@/utils/common.js";
export default {
  name: "CusChatSupervise",
  components: {
    CusChatView,
    // AddMemberView,
    StaffTree,
    CreateActiveCode
  },
  data() {
    return {
      title: "选择使用成员",
      tableSelectList: [], //当前选中的表格项
      tableData: [],
      authorityContainer: [],   // 按钮操作权限 0位指可新建/编辑/删除与否，1位表示可下载与否，2位表示活码标签管理，3位表示活码欢迎语管理
      // loading: false,
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 20,
      },
      formInline: {
        pageNum: 1,
        pageSize: 20,
        userList: [], //使用成员userId集合
        sceneName: "",   //使用场景
        creatorName: "",   //创建人名称
        startTime: "",   //开始时间
        endTime: "",   //结束时间
      },
      pageSizes: [20, 50, 100, 200, 500], //分页条数
      activeCodeVisible: false,//新建活码弹窗
      searchSelectTime: [],//搜索----选中的时间段
      dialogVisibleTree: false,  //成员添加
      currentSelectMember: [], //组件中要显示-选中的成员
      searchMenNames: [], //当前 搜索框-选中的成员
      markLength: 0,
      ceTitle: "",//新增/编辑活码标题
      editData: null,//编辑的活码数据
      timer: null,//定时器
    };
  },
  created() {
    this.getActivityData();
  },
  watch: {
    // markLength(val){
    //   if(this.markLength == this.currentSelectMember.length){
    //     this.getActivityData()
    //   }
    // },
    btnAuthority: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          newVal.forEach(item => {
            if (item.pname == '拓客活码') {
              let senBtnAuthority = item.cfunBu
              let arr = ['kxjbjsc', 'kxz', 'hmbqgl', 'hmhyygl']
              this.authorityContainer = []
              arr.forEach(item => {
                if (senBtnAuthority.indexOf(item) != -1) {
                  // 有权限
                  this.authorityContainer.push(true)
                } else {
                  // 没有权限
                  this.authorityContainer.push(false)
                }
              })
            }
          })
          console.log('this.authorityContainer', this.authorityContainer)
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    btnAuthority() {
      return this.$store.state.tagsView.roleAuthrority
    }
  },

  destroyed() {
    if (this.timer != null) {
      console.log('sssssss1111')
      clearTimeout(this.timer)
    }
  },
  methods: {
    // 时间处理
    selectTime(dataTime) {
      if (dataTime == null) {
        this.formInline.startTime = "";
        this.formInline.endTime = "";
      } else {
        this.formInline.startTime = dataTime[0];
        this.formInline.endTime = dataTime[1];
      }
      this.formInline.pageNum = 1
      this.getActivityData();
    },
    //保存成功的列表获取
    getRefresh() {
      getActivityList(this.formInline, localStorage.getItem("Authorization"), true).then((res) => {
        if (res.error.code == 200) {
          clearTimeout(this.timer)
          let tempArr = []//标记数据的状态
          //暂存结果数组
          let resultArr = res.data.result
          //列表处于生成中的数据(未生成成功的数据)
          let creatArr = this.tableData.filter(v => {
            if (v.qrStatus == 1) {
              tempArr.push(0)
            }
            return v.qrStatus == 1
          })
          creatArr.map((v, index) => {
            for (let i = 0; i < resultArr.length; i++) {
              if (v.qrId == resultArr[i].qrId) {
                //已经生成成功
                if (resultArr[i].qrStatus == 2) {
                  tempArr[index] = 1
                  //替换数据
                  let str = JSON.parse(JSON.stringify(this.tableData))
                  for (let j = 0; j < str.length; j++) {
                    if (v.qrId == str[j].qrId) {
                      str[j] = resultArr[i]
                      this.tableData = str;
                      break
                    }
                  }
                }
                break
              }
            }
          })
          //如果还有生成中的数据
          if (tempArr.indexOf(0) != -1) {
            this.timer = setTimeout(() => { this.getRefresh() }, 5000);
          }
        }
      }).catch((err) => { })
    },
    // 获取活码-列表
    getActivityData() {
      getActivityList(this.formInline, localStorage.getItem("Authorization")).then((res) => {
        if (res.error.code == 200) {
          if (this.timer != null) {
            clearTimeout(this.timer)
          }
          this.pageparm.total = res.data.total
          this.tableData = res.data.result;
          //判断是否有生成中的数据
          for (let i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].qrStatus == 1) {
              //如果有生成中的数据则创建一个5s延时
              this.timer = setTimeout(() => { this.getRefresh() }, 5000);
              break
            }
          }
        }
      }).catch((err) => { })
    },
    //点击行触发，选中或不选中复选框
    handleRowClick(row, column, event) {
      this.$refs.cusChatTable.toggleRowSelection(row);
    },
    //双击表格触发编辑
    handleRowDBClick(row) {
      if (this.authorityContainer[0]) {
        if (row.qrStatus == 1) {
          this.$message.warning(`数据生成中，不可编辑！`)
        } else if (row.qrStatus == 2) {
          this.ceTitle = "活码详情"
          this.editData = row
          this.activeCodeVisible = true
        }
      }
    },
    // 树
    closeTree(val) {
      this.dialogVisibleTree = false;
    },
    //对象数组去重(根据userId去重)
    getArrSet(Arr, id) {
      var obj = {};
      const arrays = Arr.reduce((setArr, item) => {
        obj[item[id]] ? '' : obj[item[id]] = true && setArr.push(item);
        return setArr;
      }, []);
      return arrays;
    },
    //树确认回调
    clickSubmitTree(val) {
      this.currentSelectMember = val.currentMember
      this.formInline.pageNum = 1;
      // this.markLength = 0
      this.formInline.userList = []
      this.searchMenNames = val.currentIdName
      val.sendArray.forEach(item => {
        this.formInline.userList.push(item.userId)
      })
      this.getActivityData();
      this.dialogVisibleTree = false;
    },
    // 搜索-添加成员
    clickAddMember() {
      this.dialogVisibleTree = true;
    },
    // 搜索-添加成员---清空
    searchCloseTag() {
      this.searchMenNames = [];
      this.currentSelectMember = []
      this.formInline.userList = []
      // this.markLength = 0
      this.searchFn()
    },
    //搜索 (更改条件触发)
    searchFn() {
      this.formInline.pageNum = 1;
      this.getActivityData();
    },
    // 打开新建活码
    openCode() {
      this.ceTitle = "新建活码"
      this.editData = null
      this.activeCodeVisible = true
    },
    // 取消新建活码
    createCancelHandle() {
      this.activeCodeVisible = false
    },
    //新建活码成功
    createSuccess(codeMsg, tipTxt, userList) {
      this.activeCodeVisible = false
      if (codeMsg.qrType == 0) {
        //单人
        this.$confirm('二维码生成成功！', '', {
          confirmButtonText: '下载',
          center: true,
          showCancelButton: false,
          iconClass: 'el-icon-success',
        })
          .then(() => {
            let fileName = userList[0].userName + ".png"
            this.saveDownloadHandle(codeMsg, fileName)
          })
          .catch(() => { });
      } else { }
      this.formInline.pageNum = 1
      this.getActivityData();
    },
    // 删除活码
    handleDel(row) {
      this.$confirm("", "", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        message: `<div style="font-size:15px;">确定删除该内容？</div><div style="font-size:12px;color:#999999">（该活码删除后将失效，客户不能再添加职员，删除活码对应活码统计记录也将同步删除！）</div>`,
        dangerouslyUseHTMLString: true,
        iconClass: "el-icon-warning",
        customClass: "delete-messege",
        center: true
      }).then(() => {
        delActiveCode(row.qrId, localStorage.getItem("Authorization")).then((res) => {
          if (res.error.code == 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.getActivityData();
          }
        })
      }).catch(() => { });
    },
    //批量删除活码
    batchDelete() {
      if (this.tableSelectList.length == 0) {
        this.$message.warning(`请勾选要删除的选项!`)
      } else {
        let temp = this.tableSelectList.some(function (item, index, array) {
          return item.qrStatus == 1;
        })
        if (temp) {
          this.$message.warning(`不可删除生成中的数据！`)
        } else {
          this.$confirm('', '', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            message: `<div style="font-size:15px;">确定删除选中的内容？</div><div style="font-size:12px;color:#999999">（该活码删除后将失效，客户不能再添加职员，删除活码对应活码统计记录也将同步删除！）</div>`,
            dangerouslyUseHTMLString: true,
            iconClass: "el-icon-warning",
            customClass: "delete-messege",
            center: true
          }).then(() => {
            let qrIds = this.tableSelectList.map(v => {
              return v.qrId
            })
            batchDelActiveCode(qrIds, localStorage.getItem("Authorization")).then((res) => {
              if (res.error.code == 200) {
                this.$message({ type: 'success', message: '删除成功!' });
                this.getActivityData();
              }
            }).catch(() => { })
          }).catch(() => { })
        }
      }
    },
    //新建单人的下载
    saveDownloadHandle(row, name) {
      let urlIt = `/api/qywechat/activity/getImg/${row.qrId}`;  //下载接口
      let fileName = name;
      this.$http({
        method: "get",
        url: this.$baseUrl + urlIt,   //this.domainName 是域名  比如：http://192.168.2.160:8080
        responseType: "blob",
        headers: {
          "authorization": localStorage.getItem("Authorization")
        }
      }).then(function (response) {
        if (response.data.type === 'application/octet-stream') {
          //获取http头部的文件名信息，若无需重命名文件，将下面这行删去
          //兼容ie内核，360浏览器的兼容模式
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            const blob = new Blob([response.data])
            window.navigator.msSaveOrOpenBlob(blob, fileName)
          } else {
            //火狐谷歌的文件下载方式
            const blob = new Blob([response.data])
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a') // 创建a标签
            link.href = url
            link.download = fileName // 文件重命名，若无需重命名，将该行删去
            link.click()
            URL.revokeObjectURL(url) // 释放内存
          }
        } else {
          this.$message('下载错误')
        }
      });
    },
    // 下载
    downloadHandle(row, index) {
      console.log(888, row.configList);
      let urlIt = `/api/qywechat/activity/getImg/${row.qrId}`;  //下载接口
      let fileName = "";
      let $t = this;
      let flagTableData = JSON.parse(JSON.stringify($t.tableData))

      const handName = () => {
        const repair = (i) => {
          if (i >= 0 && i <= 9) {
            return "0" + i;
          } else {
            return i;
          }
        }

        var date = new Date();//当前时间
        var year = date.getFullYear() //年
        var month = repair(date.getMonth() + 1);//月
        var day = repair(date.getDate());//日
        var hour = repair(date.getHours());//时
        var minute = repair(date.getMinutes());//分
        var second = repair(date.getSeconds());//秒

        //当前时间 
        var curTime = year  + month +  day+
          hour +  minute +  second;
          // console.log(666, curTime);
        return curTime;


      }
      switch (row.qrType) {
        case 0: fileName = row.configList[0].userName + ".png"; break;
        case 1: fileName = "批量单人二维码.zip"; break;
        case 2: fileName = '多人活码 ' + handName() + ".png"; break;
        default: break;
      }
      for (let i = 0; i < flagTableData.length; i++) {
        if (flagTableData[i].qrId == row.qrId) {
          flagTableData[i].download = true;
          break
        }
      }
      $t.tableData = flagTableData
      this.$http({
        method: "get",
        url: this.$baseUrl + urlIt,   //this.domainName 是域名  比如：http://192.168.2.160:8080
        responseType: "blob",
        headers: {
          "authorization": localStorage.getItem("Authorization")
        }
      }).then(function (response) {
        console.log(456, response);
        let flagTableArr = JSON.parse(JSON.stringify($t.tableData))
        for (let i = 0; i < flagTableArr.length; i++) {
          if (flagTableArr[i].qrId == row.qrId) {
            flagTableArr[i].download = false;
            break
          }
        }
        $t.tableData = flagTableArr
        if (response.data.type === 'application/octet-stream') {
          //获取http头部的文件名信息，若无需重命名文件，将下面这行删去
          //兼容ie内核，360浏览器的兼容模式
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            const blob = new Blob([response.data])
            window.navigator.msSaveOrOpenBlob(blob, fileName)
          } else {
            //火狐谷歌的文件下载方式
            const blob = new Blob([response.data])
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a') // 创建a标签
            link.href = url
            link.download = fileName // 文件重命名，若无需重命名，将该行删去
            link.click()
            URL.revokeObjectURL(url) // 释放内存
          }
        } else {
          $t.$message('下载错误')
        }
      });
    },
    //批量下载
    batchDownLoadHandle() {
      if (this.tableSelectList.length === 0) {
        this.$message.warning(`请勾选要下载的数据!`)
      } else {
        let temp = this.tableSelectList.some(function (item, index, array) {
          return item.qrStatus == 1;
        })
        if (temp) {
          this.$message.warning(`不可下载生成中的数据！`)
        } else {
          this.$confirm('确定下载选中的数据？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            center: true,
            type: 'warning'
          })
            .then(() => {
              this.tableSelectList.map((item, index) => {
                this.downloadHandle(item, index);
              })
            })
            .catch(() => { })
        }
      }
    },
    // 编辑活码
    editHandle(row) {
      this.activeCodeVisible = true
      this.ceTitle = "活码详情"
      this.editData = row
    },
    //分页回调
    callBack(parm) {
      this.formInline.pageNum = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.getActivityData()
    },
    handleSelectionChange(val) {
      this.tableSelectList = val; //后面有ID过滤出来,直接传参
    },
    // 跳转标签管理或欢迎语标签页面
    toLabelManagement(btn) {
      if (this.timer != null) {
        clearTimeout(this.timer)
      }
      if (btn === '标签管理') {
        this.$router.push('/code/StaffLabel');
      } else if (btn === '欢迎语管理') {
        this.$router.push('/code/Welcome');
      }
      if (btn === '客户管理') {
        this.$router.push('/code/clientModel');
      } else if (btn === '活码统计') {
        this.$router.push('/code/codeStatistics');
      }
    },
        /** 格式化时间 */
    getfTime(time) {
      return timeFormat(time, "yyyy-mm-dd hh:MM:ss");
    },
  },
};
</script>
<style lang="scss" scoped>
.code-staff {
  .name-wrap {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .code-staff-search {
    margin-bottom: 10px;

    .code-search-left {
      display: flex;
      align-items: center;

      /deep/.add-per-input {
        margin-right: 10px;
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        position: relative;
        cursor: pointer;

        .el-icon-close {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 5px;
        }
      }
    }

    .code-search-right {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
    }

    .csr-right {
      .el-button {
        border: 1px solid #409eff;
        color: #409eff;
      }
    }

    .el-tag--plain {
      border-color: #DCDFE6;
      color: #C0C4CF;
    }
  }

  .table-btns {
    padding: 0;
  }
}
</style>